import { render } from "./houseDetails.vue?vue&type=template&id=dd1309bc"
import script from "./houseDetails.vue?vue&type=script&lang=js"
export * from "./houseDetails.vue?vue&type=script&lang=js"

import "./houseDetails.vue?vue&type=style&index=0&id=dd1309bc&lang=scss"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__